import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LicenseState } from './license.reducers';

export const licenseState = createFeatureSelector<LicenseState>('license');
export const licenseSelector = createSelector(licenseState, state => state);
